import { EntityState, EntityAdapter, createEntityAdapter } from "@ngrx/entity";
import { Action, createReducer, on } from "@ngrx/store";
import { RoomStreamVORaw } from "@youm-front/room/domain";
import { RoomActions, RoomStreamActions } from "../actions";
import { RoomEvents, RoomStreamEvents } from "../events";

export const ROOM_LOCAL_STREAMS_FEATURE_KEY = "roomLocalStreams";

export interface RoomLocalStreamsState extends EntityState<RoomStreamVORaw> {}

export const roomLocalStreamsAdapter: EntityAdapter<RoomStreamVORaw> =
  createEntityAdapter<RoomStreamVORaw>({
    selectId: (_) => _.streamId
  });

const initialState: RoomLocalStreamsState =
  roomLocalStreamsAdapter.getInitialState();

const reducer = createReducer(
  initialState,
  on(
    RoomActions.init,
    RoomActions.destroy,
    RoomActions.reset,
    () => initialState
  ),
  on(
    RoomActions.publishScreenStreamSuccess,
    RoomActions.publishWebcamStreamSuccess,
    RoomActions.publishLocalVideoStreamSuccess,
    RoomActions.publishLocalAudioStreamSuccess,
    (state, action) =>
      roomLocalStreamsAdapter.upsertOne(action.roomStreamVO.value, state)
  ),
  on(RoomEvents.roomStreamUpdate, (state, action) =>
    // Update only if exists in this store.
    // Don't use upsertOne, may be duplication with remote streams
    roomLocalStreamsAdapter.updateOne(
      {
        id: action.roomStreamUpdateEventVO.value.streamId,
        changes: action.roomStreamUpdateEventVO.value
      },
      state
    )
  ),
  on(
    RoomStreamActions.roomStreamDeleteSuccess,
    RoomStreamEvents.roomStreamDeleteEvent,
    (state, action) =>
      roomLocalStreamsAdapter.removeOne(
        action.roomStreamDeleteCmd.value.streamId,
        state
      )
  ),
  on(RoomActions.disposeRoomLocalData, (state) =>
    roomLocalStreamsAdapter.removeAll(state)
  )
);

export function roomLocalStreamsReducer(
  state: RoomLocalStreamsState | undefined,
  action: Action
) {
  return reducer(state, action);
}
